<div class="page-header-main">
  <div class="row align-items-center justify-content-between">
    <div class="col-md-auto col-sm-auto col">
      <div class="content-header">
        <h1>Marquee</h1>
      </div>
    </div>
    <!-- <div class="col-md-auto col-sm-auto col-auto">
      <button (click)="openAddEditDialog()" class="btn blue-btn btn-sm">
        <i class="fas fa-plus"></i> Add Marquee
      </button>
    </div> -->
  </div>
</div>

<div class="table-responsive" style="height: 532px">
  <table
    mat-table
    [dataSource]="dataSource"
    class="table grid_table table-bordered table-hover"
  >
    <!-- ACTION Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell class="table-column-100" *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let marquee" class="gap-2">
        <mat-icon
          class="interButtonIcons text-success"
          (click)="openAddEditDialog(marquee)"
          >edit</mat-icon
        >
        <mat-icon
          class="interButtonIcons text-danger"
          (click)="deleteMarquee(marquee)"
          >delete</mat-icon
        >
      </td>
    </ng-container>
    <!-- Marquee Text Column -->
    <ng-container matColumnDef="marqueeText">
      <th class="table-column-400" mat-header-cell *matHeaderCellDef>
        Marquee Text
      </th>
      <td mat-cell *matCellDef="let marquee">{{ marquee.marqueeText }}</td>
    </ng-container>

    <!-- Link Text Column -->
    <ng-container matColumnDef="linkText">
      <th class="table-column-200" mat-header-cell *matHeaderCellDef>
        Link Text
      </th>
      <td mat-cell *matCellDef="let marquee">{{ marquee.linkText }}</td>
    </ng-container>

    <!-- Created By Column -->
    <ng-container matColumnDef="createdBy">
      <th class="table-column-200" mat-header-cell *matHeaderCellDef>
        Created By
      </th>
      <td mat-cell *matCellDef="let marquee">{{ marquee.createdBy }}</td>
    </ng-container>

    <!-- Created On Column -->
    <ng-container matColumnDef="createdOn">
      <th class="table-column-200" mat-header-cell *matHeaderCellDef>
        Created On
      </th>
      <td mat-cell *matCellDef="let marquee">
        {{ marquee.createdOn | date: "dd-MM-yyyy hh:mm a" }}
      </td>
    </ng-container>

    <!-- Approved By Column -->
    <ng-container matColumnDef="approvedBy">
      <th class="table-column-200" mat-header-cell *matHeaderCellDef>
        Approved By
      </th>
      <td mat-cell *matCellDef="let marquee">{{ marquee.approvedBy }}</td>
    </ng-container>

    <!-- Approved Date Column -->
    <ng-container matColumnDef="approvedDate">
      <th class="table-column-200" mat-header-cell *matHeaderCellDef>
        Approved Date
      </th>
      <td mat-cell *matCellDef="let marquee">
        {{ marquee.approvedDate | date: "short" }}
      </td>
    </ng-container>

    <!-- Approved Status Column -->
    <ng-container matColumnDef="approvedStatus">
      <th class="table-column-200" mat-header-cell *matHeaderCellDef>
        Approved Status
      </th>
      <td mat-cell *matCellDef="let marquee">{{ marquee.approvedStatus }}</td>
    </ng-container>

    <!-- Paginator Footer Column -->
    <ng-container matColumnDef="paginator">
      <td
        mat-footer-cell
        *matFooterCellDef
        [attr.colspan]="displayedColumns.length"
      >
        <mat-paginator
          style="margin-top: 172px"
          [length]="totalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 20, 50]"
          showFirstLastButtons
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </td>
    </ng-container>

    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <!-- Data Rows -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <!-- Footer Row with Paginator -->
    <tr mat-footer-row *matFooterRowDef="['paginator']"></tr>

    <!-- No Data Row -->
    <tr class="mat-row" *matNoDataRow>
      <td
        class="mat-cell"
        colspan="12"
        style="text-align: center; padding: 2rem"
      >
        No marquee found.
      </td>
    </tr>
  </table>
</div>
